import * as React from "react";
import type { SVGProps } from "react";
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#share_svg__a)">
      <path d="M6 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M18 22c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M18 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" />
      <path d="M9 11.5c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34l6-3a.993.993 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-6 3c-.14.07-.3.11-.45.11zM15 17.5c-.15 0-.3-.03-.45-.11l-6-3a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.69 1.34-.45l6 3c.49.25.69.85.45 1.34-.18.35-.53.55-.9.55z" />
    </g>
    <defs>
      <clipPath id="share_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShare;
